import React from 'react';
import { Link } from 'react-router-dom';

import {
    Container,
} from './../../../components';

export const SidebarWithNavbar = () => (
    <Container>
    </Container>
);
